import { DispatcherEvent } from '@carvana/merch-native';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext';
import sendMessageToNative from './sendMessageToNative';

export default function useFullscreenDispatcher() {
  const { isAnyModalOpen, isSoftPullModalOpen } = useContext(ModalContext);

  const isWebModalOpen = isAnyModalOpen && !isSoftPullModalOpen;

  useSubsequentEffect(() => {
    sendMessageToNative(
      isWebModalOpen
        ? DispatcherEvent.EnterFullscreen
        : DispatcherEvent.LeaveFullscreen,
      {}
    );
  }, [isWebModalOpen]);
}
